import type { DeleteComponentTemplateConfirmationModalProps } from "@v1/types/modalTypes";

import * as React from "react";

import toast from "@v1/components/designSystem/alert/Toast";
import {
  componentTemplatesRouter,
  componentTemplatesUtils,
} from "@v1/trpc/routes/componentTemplates";
import DeleteConfirmationModal from "@v2/components/DeleteConfirmationModal";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { useModal } from "@v2/store/modalStore";

export const DeleteComponentTemplateConfirmationModal = ({
  template,
}: DeleteComponentTemplateConfirmationModalProps) => {
  const modal = useModal();
  const projectId = useCurrentProjectId();
  const {
    mutateAsync: deleteComponentTemplate,
    isSuccess,
    isPending,
  } = componentTemplatesRouter.delete.useMutation();

  const closeModal = React.useCallback(() => {
    modal.closeModal({ type: "deleteComponentTemplateConfirmationModal" });
  }, [modal]);

  React.useEffect(() => {
    if (isSuccess) {
      toast({
        header: "Template Deleted",
        message: `${template.name} deleted successfully! 🎉`,
      });

      void componentTemplatesUtils.find.invalidate();

      closeModal();
    }
  }, [isSuccess, closeModal, template.name]);

  if (!projectId) {
    return null;
  }

  return (
    <DeleteConfirmationModal
      onRequestClose={() => closeModal()}
      onDelete={() => {
        void deleteComponentTemplate({
          templateId: template.id,
          projectId,
        });
      }}
      assetTypeDisplayName="Saved Component"
      assetName={template.name}
      isLoading={isPending}
    />
  );
};
